import moment from "jalali-moment"

const gregorianDate = (date:any) => {
    return date != null ? moment(date).format('YYYY-MM-DDTHH:mm:ss') : null
}

export default gregorianDate